const clampMoney = (n) => {
  const v = Number(n);
  if (!Number.isFinite(v)) return 0;
  return Math.max(0, v);
};

const applyPercentOff = (amount, percentOff) => {
  const a = clampMoney(amount);
  const pct = Number(percentOff);
  if (!Number.isFinite(pct) || pct <= 0) return a;
  return clampMoney(a * (1 - pct / 100));
};

const applyAmountOff = (amount, amountOff) => {
  const a = clampMoney(amount);
  const off = Number(amountOff);
  if (!Number.isFinite(off) || off <= 0) return a;
  return clampMoney(a - off);
};

const discountSortKey = (d) => {
  // Mirror backend ordering (stripe_views._discount_sort_key):
  // 1) percent discounts first
  // 2) amount discounts after
  // 3) trial-only/none last
  // Within a kind: global first, then coupon
  const isPercent = d?.percent_off != null;
  const isAmount = !isPercent && d?.amount_off != null;
  const kindRank = isPercent ? 0 : isAmount ? 1 : 2;
  const sourceRank = d?.source === "global" ? 0 : 1;
  return [kindRank, sourceRank];
};

export const computeStackedPrice = ({ base, discounts }) => {
  const baseAmount = clampMoney(base);
  const list = Array.isArray(discounts) ? discounts.filter(Boolean) : [];
  const sorted = [...list].sort((a, b) => {
    const ak = discountSortKey(a);
    const bk = discountSortKey(b);
    return ak[0] - bk[0] || ak[1] - bk[1];
  });

  let amount = baseAmount;
  for (const d of sorted) {
    if (d?.percent_off != null) amount = applyPercentOff(amount, d.percent_off);
    else if (d?.amount_off != null) amount = applyAmountOff(amount, d.amount_off);
  }
  return amount;
};

export const computeTrialDays = ({ discounts }) => {
  const list = Array.isArray(discounts) ? discounts.filter(Boolean) : [];
  return list.reduce((total, d) => {
    const days = Number(d?.free_trial_days || 0);
    if (!Number.isFinite(days) || days <= 0) return total;
    return total + days;
  }, 0);
};

